import axios from "axios";
import { toast } from "react-toastify";
import {
  NETWORK_ERROR,
  NOT_FOUND_ERROR,
  PERMISSION_ERROR,
  SERVER_ERROR,
  SERVER_NOT_RESPONDING_ISSUE,
  REQUEST_TIMEOUT_ERROR,
} from "../utils/constant";
import i18next from "i18next";


const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: "application/json",
  },
  timeout: 13000, // 10 seconds
  withCredentials: false,
});

async function isOnline() {
  try {
      await fetch("https://www.google.com/favicon.ico", {
      method: "HEAD",
      mode: "no-cors",
    });
    return true; // Internet is accessible
  } catch (error) {
    return false; // No internet access
  }
}

// Interceptor for handling success and error responses
async function errorResponseHandler(error) {
  if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
    toast.error(REQUEST_TIMEOUT_ERROR);
  }
 if (!error.response) {
    // Network error
    toast.error(SERVER_NOT_RESPONDING_ISSUE);
  } else {
    const { status, data } = error.response;
    // Handle specific HTTP status codes
    if (status === 403) {
      toast.error(PERMISSION_ERROR);
    } else if (status === 404) {
      toast.error(NOT_FOUND_ERROR);
    } else if (status >= 500) {
      toast.error(SERVER_ERROR);
    } else {
      const message = data?.message ? data?.message : "An unexpected error occurred.";
      console.log('message------------>', message);
      console.log('translated message---------->', i18next.t(message))
        toast.error(i18next.t(message));
    }
  }

  return Promise.reject(error);
}

// Interceptor for handling successful responses
function successResponseHandler(response) {
  // Optionally display a success message
  if (response?.data?.message) {
    toast.success(response.data.message);
  }
  return response;
}

axiosInstance.interceptors.request.use(


  async (config) => {
    const isConnectedToInternet = await isOnline();
 
 
    if (!isConnectedToInternet) {
      toast.error(NETWORK_ERROR);
    }
    const token = localStorage.getItem("token"); // Retrieve token from localStorage or any other storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Apply interceptors to the axios instance
axiosInstance.interceptors.response.use(
  successResponseHandler,
  errorResponseHandler
);

export default axiosInstance;
